import { Link } from "react-router-dom";
import useScrollReveal from "../../hooks/useScrollReveal";

const coconeuseTeasers = [
  {
    key: 'deborah', name: 'Deborah', path: '/coconeuses/deborah',
    image: 'https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/6r9rpmdm_DSC01487.jpg',
    specialty: 'Éveil · Harmonisation · Transformation',
  },
  {
    key: 'ameDiva', name: 'Âme Diva', path: '/coconeuses/ame-diva',
    image: 'https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2d7ag7eo_DSC00736.jpg',
    specialty: 'La voix comme médecine · Le chant comme passage',
  },
  {
    key: 'valerie', name: 'Valérie', path: '/coconeuses/valerie',
    image: 'https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/as2yuj7o_WhatsApp%20Image%202026-02-01%20at%2018.53.40.jpeg',
    specialty: 'Yoga sensible & vibrant',
  },
];

const CoconeusesSection = () => {
  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const cardsReveal = useScrollReveal({ threshold: 0.1 });
  const ctaReveal = useScrollReveal({ threshold: 0.2 });

  return (
    <section id="coconeuses-home" className="py-24 sm:py-36 px-6 bg-[#E8D2B5]/50">
      <div className="max-w-3xl mx-auto">

        {/* Header */}
        <div
          ref={headerReveal.ref}
          className={`text-center mb-20 space-y-6 scroll-reveal-slow ${headerReveal.isVisible ? "visible" : ""}`}
        >
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#F3E5CF]">
            Le cercle
          </p>
          <h3 className="font-serif text-2xl sm:text-3xl text-[#3F2A24]">
            Le cercle
          </h3>
          <div className="w-12 h-[1px] bg-[#3F2A24]/20 mx-auto" />
          <div className="space-y-3 max-w-md mx-auto">
            <p className="font-serif text-base sm:text-lg text-[#3F2A24]/70 italic leading-[2.2]">
              Celles qui accompagnent la traversée.
            </p>
            <p className="font-serif text-base sm:text-lg text-[#3F2A24]/60 leading-[2.2]">
              Une présence.
            </p>
            <p className="font-serif text-base sm:text-lg text-[#3F2A24]/60 leading-[2.2]">
              Un soin.
            </p>
            <p className="font-serif text-base sm:text-lg text-[#3F2A24]/60 leading-[2.2]">
              Une intelligence du vivant
            </p>
            <p className="font-serif text-base sm:text-lg text-[#3F2A24]/60 italic leading-[2.2]">
              qui agit au-delà des mots.
            </p>
          </div>
        </div>

        {/* Teaser cards — 3 coconeuses */}
        <div
          ref={cardsReveal.ref}
          className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-16"
        >
          {coconeuseTeasers.map((c, i) => (
            <Link
              to={c.path}
              key={c.key}
              className={`group text-center space-y-4 formula-card-premium scroll-reveal scroll-reveal-delay-${i + 1} ${cardsReveal.isVisible ? "visible" : ""}`}
              data-testid={`home-coconeuse-${c.key}`}
            >
              <div className="w-32 h-32 mx-auto rounded-full overflow-hidden border-2 border-[#C5A059]/40 group-hover:border-[#C5A059] transition-colors duration-500">
                <img
                  src={c.image}
                  alt=""
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <p className="font-serif text-lg sm:text-xl text-[#3F2A24] group-hover:text-[#5C3D2E] transition-colors">
                {c.name}
              </p>
              <p className="text-[11px] tracking-[0.08em] uppercase text-[#3F2A24]/50 leading-relaxed">
                {c.specialty}
              </p>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div
          ref={ctaReveal.ref}
          className={`text-center scroll-reveal ${ctaReveal.isVisible ? "visible" : ""}`}
        >
          <Link
            to="/coconeuses"
            className="inline-flex items-center justify-center px-12 py-5 rounded-full bg-[#8d7a6b] text-[#F3E5CF] text-xs tracking-[0.18em] uppercase font-medium hover:bg-[#3F2A24] transition-all duration-500 min-h-[52px]"
            data-testid="home-discover-coconeuses-btn"
          >
            Découvrir les coconeuses
          </Link>
        </div>
      </div>
    </section>
  );
};

/* ═══ CONSERVATION TEMPORAIRE — ancien CoconeusesSection ═══
 *
 * Affichait 7 coconeuses complètes avec bios, photos et CTAs individuels :
 * Valérie, Heather, Âme Diva, Deborah, Emma, Stéphanie, Maïté
 * Titre: "MES COCONEUSES"
 * Intro longue: "Mes retraites COCON ne seraient pas possibles..."
 * "Ces femmes médecines magnifiques..."
 * "DÉCOUVREZ-LES. DÉCOUVREZ LEUR HISTOIRE."
 * Chaque carte: photo ronde + nom + spécialité + bio complète + CTA personnel
 *
 * ═══ FIN CONSERVATION TEMPORAIRE ═══ */

export default CoconeusesSection;
